// @flow

import { OpenPanel } from '@openpanel/web'

export type Config = {
  clientId: string,
  apiUrl: string,
  trackScreenViews: boolean,
  trackOutgoingLinks: boolean,
  trackAttributes: boolean,
  trackHashChanges: boolean,
  waitForProfile: boolean,
  disabled: boolean,
}

export type Source = 'web' | 'smarttv' | 'mobile'

export type AppContext = {
  source: Source,
  brandId: string,
  serviceProviderId: string,
}

export const createOpenPanel = (config: Config, appContext: AppContext) => {
  const op = new OpenPanel({
    trackScreenViews: false,
    trackOutgoingLinks: false,
    trackAttributes: false,
    trackHashChanges: false,
    disabled: true,
    ...config,
  })

  op.setGlobalProperties({
    environment: appContext.brandId,
    serviceProvider: appContext.serviceProviderId,
    source: appContext?.source,
  })

  return op
}
